'use client';

import { c as _c } from "react/compiler-runtime";
import { ApiErrors } from '@repo/features/error';
import { toCountryCode } from '@repo/sdk/helpers/phone';
import { PhoneField } from '@repo/form/phone';
import { Button, Separator } from '@repo/ui/components';
import { PropsWithChildren } from 'react';
import { ExistingCompanyAlert } from './existing-company-alert';
import { useCreateCompanyForm } from './use-create-company-form';
const FormSection = t0 => {
  const $ = _c(5);
  const {
    children,
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h2 className="text-2xl font-bold">{title}</h2>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <div className="flex flex-col gap-6" data-sentry-component="FormSection" data-sentry-source-file="form.tsx">{t1}{children}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const CreateCompanyForm = () => {
  const $ = _c(121);
  const {
    AppField,
    AppForm,
    closeCreateCompanySheet,
    country,
    existingCompany,
    form,
    handleSubmit,
    handleVatBlur,
    isAllOrganisationsSelected,
    isPending,
    isSubmitDisabled,
    isVatLookupPending,
    submitErrorMessage,
    vatLookupMessage
  } = useCreateCompanyForm();
  let t0;
  if ($[0] !== handleSubmit) {
    t0 = event => {
      event.preventDefault();
      event.stopPropagation();
      handleSubmit();
    };
    $[0] = handleSubmit;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== isAllOrganisationsSelected) {
    t1 = field => <field.FormOrganisationSelect disabled={!isAllOrganisationsSelected} label="Organisation *" />;
    $[2] = isAllOrganisationsSelected;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== AppField || $[5] !== t1) {
    t2 = <FormSection title="Business data" data-sentry-element="FormSection" data-sentry-source-file="form.tsx"><AppField name="organisation_id" data-sentry-element="AppField" data-sentry-source-file="form.tsx">{t1}</AppField></FormSection>;
    $[4] = AppField;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Separator data-sentry-element="Separator" data-sentry-source-file="form.tsx" />;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isPending) {
    t4 = field_0 => <field_0.FormCompanyTypeSelect allowedValues={["broker", "haulier", "shipper"]} isPending={isPending} label="Company type *" placeholder="Pick type" required={true} />;
    $[8] = isPending;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== AppField || $[11] !== t4) {
    t5 = <AppField name="type" data-sentry-element="AppField" data-sentry-source-file="form.tsx">{t4}</AppField>;
    $[10] = AppField;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== isPending) {
    t6 = field_1 => <field_1.FormCountrySelect display="name" isPending={isPending} label="Country *" required={true} variant="outline" />;
    $[13] = isPending;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== AppField || $[16] !== t6) {
    t7 = <AppField name="country" data-sentry-element="AppField" data-sentry-source-file="form.tsx">{t6}</AppField>;
    $[15] = AppField;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t5 || $[19] !== t7) {
    t8 = <FormSection title="Company settings" data-sentry-element="FormSection" data-sentry-source-file="form.tsx">{t5}{t7}</FormSection>;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Separator data-sentry-element="Separator" data-sentry-source-file="form.tsx" />;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== handleVatBlur || $[23] !== isPending || $[24] !== isVatLookupPending) {
    t10 = field_2 => <field_2.Input description="Enter the VAT number to auto-fill the remaining fields (verified via Creditsafe)" disabled={isPending || isVatLookupPending} label="VAT No" onBlur={() => void handleVatBlur(field_2.state.value)} placeholder="GB123456789" />;
    $[22] = handleVatBlur;
    $[23] = isPending;
    $[24] = isVatLookupPending;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== AppField || $[27] !== t10) {
    t11 = <AppField name="vat" data-sentry-element="AppField" data-sentry-source-file="form.tsx">{t10}</AppField>;
    $[26] = AppField;
    $[27] = t10;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== vatLookupMessage) {
    t12 = vatLookupMessage ? <p className="text-sm text-zinc-500">{vatLookupMessage}</p> : null;
    $[29] = vatLookupMessage;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== existingCompany) {
    t13 = existingCompany ? <ExistingCompanyAlert company={existingCompany} /> : null;
    $[31] = existingCompany;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== isPending) {
    t14 = field_3 => <field_3.Input disabled={isPending} label="Legal name *" placeholder="Acme Ltd" required={true} />;
    $[33] = isPending;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== AppField || $[36] !== t14) {
    t15 = <AppField name="title" data-sentry-element="AppField" data-sentry-source-file="form.tsx">{t14}</AppField>;
    $[35] = AppField;
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== isPending) {
    t16 = field_4 => <field_4.Input disabled={isPending} label="Address - 1 line" placeholder="Street address" />;
    $[38] = isPending;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== AppField || $[41] !== t16) {
    t17 = <AppField name="address.address" data-sentry-element="AppField" data-sentry-source-file="form.tsx">{t16}</AppField>;
    $[40] = AppField;
    $[41] = t16;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== isPending) {
    t18 = field_5 => <field_5.Input disabled={isPending} label="Address - 2 line" placeholder="Building, floor, unit" />;
    $[43] = isPending;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== AppField || $[46] !== t18) {
    t19 = <AppField name="address.address_second_line" data-sentry-element="AppField" data-sentry-source-file="form.tsx">{t18}</AppField>;
    $[45] = AppField;
    $[46] = t18;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== isPending) {
    t20 = field_6 => <field_6.Input disabled={isPending} label="Post code" placeholder="AB1 2CD" />;
    $[48] = isPending;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== AppField || $[51] !== t20) {
    t21 = <AppField name="address.postcode" data-sentry-element="AppField" data-sentry-source-file="form.tsx">{t20}</AppField>;
    $[50] = AppField;
    $[51] = t20;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== isPending) {
    t22 = field_7 => <field_7.Input disabled={isPending} label="City" placeholder="London" />;
    $[53] = isPending;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  let t23;
  if ($[55] !== AppField || $[56] !== t22) {
    t23 = <AppField name="address.city" data-sentry-element="AppField" data-sentry-source-file="form.tsx">{t22}</AppField>;
    $[55] = AppField;
    $[56] = t22;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  let t24;
  if ($[58] !== isPending) {
    t24 = field_8 => <field_8.Input disabled={isPending} label="Company registration number (CRN)" placeholder="123456789" />;
    $[58] = isPending;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  let t25;
  if ($[60] !== AppField || $[61] !== t24) {
    t25 = <AppField name="registration_number" data-sentry-element="AppField" data-sentry-source-file="form.tsx">{t24}</AppField>;
    $[60] = AppField;
    $[61] = t24;
    $[62] = t25;
  } else {
    t25 = $[62];
  }
  let t26;
  if ($[63] !== isPending) {
    t26 = field_9 => <field_9.Textarea disabled={isPending} label="Notes" placeholder="Your notes about company" rows={4} />;
    $[63] = isPending;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  let t27;
  if ($[65] !== AppField || $[66] !== t26) {
    t27 = <AppField name="notes" data-sentry-element="AppField" data-sentry-source-file="form.tsx">{t26}</AppField>;
    $[65] = AppField;
    $[66] = t26;
    $[67] = t27;
  } else {
    t27 = $[67];
  }
  let t28;
  if ($[68] !== t11 || $[69] !== t12 || $[70] !== t13 || $[71] !== t15 || $[72] !== t17 || $[73] !== t19 || $[74] !== t21 || $[75] !== t23 || $[76] !== t25 || $[77] !== t27) {
    t28 = <FormSection title="Company details" data-sentry-element="FormSection" data-sentry-source-file="form.tsx">{t11}{t12}{t13}{t15}{t17}{t19}{t21}{t23}{t25}{t27}</FormSection>;
    $[68] = t11;
    $[69] = t12;
    $[70] = t13;
    $[71] = t15;
    $[72] = t17;
    $[73] = t19;
    $[74] = t21;
    $[75] = t23;
    $[76] = t25;
    $[77] = t27;
    $[78] = t28;
  } else {
    t28 = $[78];
  }
  let t29;
  if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <Separator data-sentry-element="Separator" data-sentry-source-file="form.tsx" />;
    $[79] = t29;
  } else {
    t29 = $[79];
  }
  let t30;
  if ($[80] !== isPending) {
    t30 = field_10 => <field_10.Input disabled={isPending} label="Email" placeholder="office@acme.co.uk" type="email" />;
    $[80] = isPending;
    $[81] = t30;
  } else {
    t30 = $[81];
  }
  let t31;
  if ($[82] !== AppField || $[83] !== t30) {
    t31 = <AppField name="email" data-sentry-element="AppField" data-sentry-source-file="form.tsx">{t30}</AppField>;
    $[82] = AppField;
    $[83] = t30;
    $[84] = t31;
  } else {
    t31 = $[84];
  }
  let t32;
  if ($[85] !== country) {
    t32 = toCountryCode(country);
    $[85] = country;
    $[86] = t32;
  } else {
    t32 = $[86];
  }
  let t33;
  if ($[87] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = {
      phone: "phone",
      phone_country: "phone_country"
    };
    $[87] = t33;
  } else {
    t33 = $[87];
  }
  let t34;
  if ($[88] !== form || $[89] !== isPending || $[90] !== t32) {
    t34 = <PhoneField defaultCountry={t32} disabled={isPending} fields={t33} form={form} label="Phone" syncCountryWithDefault={true} variant="button-group" data-sentry-element="PhoneField" data-sentry-source-file="form.tsx" />;
    $[88] = form;
    $[89] = isPending;
    $[90] = t32;
    $[91] = t34;
  } else {
    t34 = $[91];
  }
  let t35;
  if ($[92] !== isPending) {
    t35 = field_11 => <field_11.Input disabled={isPending} label="Website (company domain)" placeholder="https://acme.co.uk" />;
    $[92] = isPending;
    $[93] = t35;
  } else {
    t35 = $[93];
  }
  let t36;
  if ($[94] !== AppField || $[95] !== t35) {
    t36 = <AppField name="website" data-sentry-element="AppField" data-sentry-source-file="form.tsx">{t35}</AppField>;
    $[94] = AppField;
    $[95] = t35;
    $[96] = t36;
  } else {
    t36 = $[96];
  }
  let t37;
  if ($[97] !== t31 || $[98] !== t34 || $[99] !== t36) {
    t37 = <FormSection title="Company contact info" data-sentry-element="FormSection" data-sentry-source-file="form.tsx">{t31}{t34}{t36}</FormSection>;
    $[97] = t31;
    $[98] = t34;
    $[99] = t36;
    $[100] = t37;
  } else {
    t37 = $[100];
  }
  let t38;
  if ($[101] !== submitErrorMessage) {
    t38 = <ApiErrors errors={submitErrorMessage} data-sentry-element="ApiErrors" data-sentry-source-file="form.tsx" />;
    $[101] = submitErrorMessage;
    $[102] = t38;
  } else {
    t38 = $[102];
  }
  let t39;
  if ($[103] !== closeCreateCompanySheet) {
    t39 = <Button onClick={closeCreateCompanySheet} type="button" variant="outline" data-sentry-element="Button" data-sentry-source-file="form.tsx">Cancel</Button>;
    $[103] = closeCreateCompanySheet;
    $[104] = t39;
  } else {
    t39 = $[104];
  }
  let t40;
  if ($[105] !== isSubmitDisabled) {
    t40 = <Button disabled={isSubmitDisabled} type="submit" data-sentry-element="Button" data-sentry-source-file="form.tsx">Create company</Button>;
    $[105] = isSubmitDisabled;
    $[106] = t40;
  } else {
    t40 = $[106];
  }
  let t41;
  if ($[107] !== t39 || $[108] !== t40) {
    t41 = <div className="flex items-center justify-between gap-3">{t39}{t40}</div>;
    $[107] = t39;
    $[108] = t40;
    $[109] = t41;
  } else {
    t41 = $[109];
  }
  let t42;
  if ($[110] !== t0 || $[111] !== t2 || $[112] !== t28 || $[113] !== t37 || $[114] !== t38 || $[115] !== t41 || $[116] !== t8) {
    t42 = <form className="flex flex-col gap-8" onSubmit={t0}>{t2}{t3}{t8}{t9}{t28}{t29}{t37}{t38}{t41}</form>;
    $[110] = t0;
    $[111] = t2;
    $[112] = t28;
    $[113] = t37;
    $[114] = t38;
    $[115] = t41;
    $[116] = t8;
    $[117] = t42;
  } else {
    t42 = $[117];
  }
  let t43;
  if ($[118] !== AppForm || $[119] !== t42) {
    t43 = <AppForm data-sentry-element="AppForm" data-sentry-component="CreateCompanyForm" data-sentry-source-file="form.tsx">{t42}</AppForm>;
    $[118] = AppForm;
    $[119] = t42;
    $[120] = t43;
  } else {
    t43 = $[120];
  }
  return t43;
};